module.exports = __webpack_public_path__ + "img/40f4.e373ab7a.jpg";